// app/javascript/controllers/venue_waiver_choice_controller.js

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["option", "status", "error"]

    connect() {
        this.restoreSelection()
    }

    /**
     * Makes the checkboxes behave as a mutually exclusive choice.
     *
     * They retain the site's normal checkbox appearance, but only one can
     * be selected at a time.
     */
    choose(event) {
        const selectedOption = event.currentTarget

        if (selectedOption.checked) {
            this.optionTargets.forEach((option) => {
                if (option !== selectedOption) {
                    option.checked = false
                }
            })

            this.statusTarget.value = selectedOption.value
            this.clearError()
            return
        }

        // The currently selected option was unchecked.
        if (this.statusTarget.value === selectedOption.value) {
            this.statusTarget.value = ""
        }
    }

    /**
     * Requires exactly one choice before the form can be submitted.
     */
    validate(event) {
        const selectedOptions =
            this.optionTargets.filter((option) => option.checked)

        if (selectedOptions.length !== 1) {
            event.preventDefault()
            this.showError()

            this.optionTargets[0]?.focus()
            return
        }

        this.statusTarget.value = selectedOptions[0].value
        this.clearError()
    }

    restoreSelection() {
        const currentValue = this.statusTarget.value

        if (!currentValue) {
            // Defensive cleanup in case the browser restored checkbox state.
            this.optionTargets.forEach((option) => {
                option.checked = false
            })

            return
        }

        this.optionTargets.forEach((option) => {
            option.checked = option.value === currentValue
        })
    }

    showError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.remove("d-none")
        }

        this.optionTargets.forEach((option) => {
            option.classList.add("is-invalid")
            option.setAttribute("aria-invalid", "true")
        })
    }

    clearError() {
        if (this.hasErrorTarget) {
            this.errorTarget.classList.add("d-none")
        }

        this.optionTargets.forEach((option) => {
            option.classList.remove("is-invalid")
            option.removeAttribute("aria-invalid")
        })
    }
}